import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DefaultSnackbarComponent } from '../components/snackbar/default/default-snackbar.component';
import { ErrorSnackbarComponent } from '../components/snackbar/error/error-snackbar.component';
import { SuccessSnackbarComponent } from '../components/snackbar/success/success-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  showDefault(message: string, duration: number = 5000): void {
    this.snackBar.openFromComponent(DefaultSnackbarComponent, {
      data: { message, duration },
      panelClass: ['default-snackbar-outer-container'],
      duration,
    });
  }

  showWarning(message: string, duration: number = 5000): void {
    this.showDefault(message, duration);
  }

  showError(message: string, duration: number = 5000): void {
    this.snackBar.openFromComponent(ErrorSnackbarComponent, {
      data: { message, duration },
      panelClass: ['error-snackbar-outer-container'],
      duration,
    });
  }

  showSuccess(message: string, duration: number = 5000): void {
    this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      data: { message, duration },
      panelClass: ['success-snackbar-outer-container'],
      duration,
    });
  }
}
